import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import getMovableMediaElements from 'editor/src/store/design/selector/getMovableMediaElements';
import { MediaElement } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import updateMediaElementOperation, { MediaUpdateActionName } from './updateMediaElementOperation';

function getMovedPosition(element: MediaElement, dx: number, dy: number): Partial<MediaElement> {
  if (element.type === 'line') {
    return { x1: element.x1 + dx, y1: element.y1 + dy, x2: element.x2 + dx, y2: element.y2 + dy };
  }
  // Only the position changes, so each element keeps its own rotation.
  return { x: element.x + dx, y: element.y + dy };
}

/**
 * Moves the elements by the same delta (mm). Nothing moves when one of them cannot move.
 * The elements share one undo step.
 */
const moveMediaElementsByOperation =
  (uuids: number[], dx: number, dy: number) =>
  (dispatch: ThunkDispatch, getState: () => RootState): boolean => {
    const targets = getMovableMediaElements(getState(), uuids);
    if (!targets) {
      return false;
    }

    batch(() => {
      targets.forEach(({ address, element }, index) => {
        dispatch(
          updateMediaElementOperation(
            address,
            getMovedPosition(element, dx, dy),
            MediaUpdateActionName.MOVED,
            index > 0,
          ),
        );
      });
    });
    return true;
  };

export default moveMediaElementsByOperation;
